import React from "react";
import { Statistic } from '../../PSY/Statistic'
import { TOTAL_COLLATERAL_RATIO, MY_COLLATERAL_RATIO } from '../../../lexicon'
import {  Decimal, Percent } from '@liquity/lib-base'
import { getCollateralRatioStyle, getTotalCollateralRatioStyle } from '../../../utils/helper'
import { StatusBadge } from "../../PSY/Badge"

type Props = {
  myCollateralRatio: Decimal
  totalCollateralRatio: Decimal
  isRecoveryMode: boolean
}

export const CollateralStats: React.FC<Props> = ({ myCollateralRatio, totalCollateralRatio, isRecoveryMode } ) => {
  const myCollateralRatioPct = new Percent(myCollateralRatio);
  const totalCollateralRatioPct = new Percent(totalCollateralRatio);

  const crStyle = getCollateralRatioStyle(myCollateralRatio, isRecoveryMode)
  const tcrStyle = getTotalCollateralRatioStyle(totalCollateralRatio)

  return (
    <div className="bg-component border-component p-5 flex flex-col justify-between">
      <div className="text-style-heading">Collateral</div>
      <div className="flex flex-col mt-6">
        <Statistic lexicon={TOTAL_COLLATERAL_RATIO} >
          <span className={tcrStyle}>
            {totalCollateralRatioPct.prettify()}
          </span>
        </Statistic>
        <Statistic lexicon={MY_COLLATERAL_RATIO}>
          <span className={crStyle}>
            {myCollateralRatioPct.prettify()}
          </span>
        </Statistic>
        <Statistic lexicon={"Collateral Status"} border={false}>
          {isRecoveryMode ? (
            <StatusBadge status='recoveryMode' />
          ) : (
            <StatusBadge status='normal' />
          )}
        </Statistic>
      </div>
    </div>
  );
};
